import React from "react";
import OrderHistorySectionCard from "@/features/my-order/features/order-history/components/OrderHistorySectionCard";
import OrderHistoryTransportationContent from "@/features/my-order/features/order-history/components/transportation-section/OrderHistoryTransportationContent";

function OrderHistoryTransportationSection() {
  return (
    <OrderHistorySectionCard
      titleKey={"order_history:transportation.transportation_info"}
      iconSrc={"truck"}
    >
      <OrderHistoryTransportationContent />
    </OrderHistorySectionCard>
  );
}

export default OrderHistoryTransportationSection;
